import { render } from "./Paraphrase.vue?vue&type=template&id=a116696c&scoped=true"
import script from "./Paraphrase.vue?vue&type=script&lang=js"
export * from "./Paraphrase.vue?vue&type=script&lang=js"

import "./Paraphrase.vue?vue&type=style&index=0&id=a116696c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a116696c"]])

export default __exports__